import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { Button } from 'components/v2/Button'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'

const ModalContainer = styled(Modal.Container)`
  max-width: 600px;
`

const SecondaryInfo = styled.div<TSFixMe>`
  font-size: 13px;
  color: #9999bd;
  white-space: nowrap;
`

export const TimeframesModal = ({ timeframes = [], closeModal }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return (
    <ModalContainer large>
      <Modal.Header>
        <Heading.H5>
          <FormattedMessage id="dictionary.timeframes" defaultMessage="Timeframes" />
        </Heading.H5>
      </Modal.Header>

      <Modal.Content>
        <TableContainer overflow>
          <Table>
            <Thead>
              <Tr>
                <Th>
                  <FormattedMessage id="dictionary.startsOn" defaultMessage="Starts on" />
                </Th>

                <Th>
                  <FormattedMessage id="dictionary.endsOn" defaultMessage="Ends on" />
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {timeframes.map((timeframe: TSFixMe, index: number): TSFixMe => {
                return (
                  <Tr key={index}>
                    <Td>
                      <FormattedDate
                        intl={intl}
                        value={timeframe.startsAt}
                        month="2-digit"
                        day="2-digit"
                        year="numeric"
                      />

                      <SecondaryInfo>
                        <FormattedTimeByDate intl={intl} date={timeframe.startsAt} />
                      </SecondaryInfo>
                    </Td>

                    <Td>
                      <FormattedDate
                        intl={intl}
                        value={timeframe.endsAt}
                        month="2-digit"
                        day="2-digit"
                        year="numeric"
                      />

                      <SecondaryInfo>
                        <FormattedTimeByDate intl={intl} date={timeframe.endsAt} />
                      </SecondaryInfo>
                    </Td>
                  </Tr>
                )
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </Modal.Content>

      <Modal.Footer>
        <Modal.Actions>
          <Button kind="cancel" onClick={(): TSFixMe => closeModal()}>
            <FormattedMessage id="dictionary.close" defaultMessage="Close" />
          </Button>
        </Modal.Actions>
      </Modal.Footer>
    </ModalContainer>
  )
}
